import { render, staticRenderFns } from "./education.view.vue?vue&type=template&id=62ca163e"
import script from "./education.view.vue?vue&type=script&lang=js"
export * from "./education.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports